export default __webpack_public_path__ + "static/media/logo.72f6fc41.png";